import { getSearchList } from 'api/cosoApi';
import Clearfix from 'components/elements/clearfix';
import { SELECT_ITEM_DEFAULT } from 'config';
import PropTypes from 'prop-types';
import React from 'react';
import AsyncSelect from 'react-select/lib/Async';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
`;
//Combobox default se lay 10 item, khi search se goi api lay theo fullName
export default class FacilitySelect extends React.PureComponent {
  static propTypes = {
    isMulti: PropTypes.bool,
    width: PropTypes.any,
    hideLabel: PropTypes.bool,
    params: PropTypes.object,
    isOnlyParent: PropTypes.bool,
    fieldForm: PropTypes.shape({
      form: PropTypes.any,
      name: PropTypes.string,
      option: PropTypes.object,
    }),
    onChange: PropTypes.func,
  };

  state = {
    itemList: [SELECT_ITEM_DEFAULT],
  };

  // componentWillMount = async () => {};

  componentDidUpdate = (prevProps) => {
    if (
      JSON.stringify(prevProps.params) !== JSON.stringify(this.props.params)
    ) {
      // console.log(prevProps.params, this.props.params, 'nextProps.params');
      this.promiseOptions();
    }
  };

  promiseOptions = (inputValue) => {
    // console.log('promiseOptions', inputValue, this.props.params);

    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(
          getSearchList(inputValue ? inputValue.trim() : '', {
            ...this.props.params,
            itemPerPage: 10000,
          }).then((res) => {
            let idParents = [];
            const data = res.data.map((item) => {
              if (this.props.isOnlyParent) {
                if (item.facilityParent) {
                  const index = _.findIndex(idParents, (str) => {
                    return str === item.facilityParent._id;
                  });
                  if (index < 0) {
                    idParents.push(item.facilityParent._id);
                  }
                  return index < 0
                    ? {
                        value: item.facilityParent._id,
                        label: item.facilityParent.FacilityNameFull,
                        obj: item,
                        
                      }
                    : null;
                } else {
                  return null;
                }
              }
              return {
                value: item._id,
                label: item.FacilityNameFull,
                obj: item,
              };
            });
            if (this.props.onInitValue && this.props.isEdit) {
              const facility = this.props.fieldForm.form.getFieldsValue()
                .facility;
              const indexInitFacility = data.findIndex(
                (item) => item.value === this.props._id
              );
              const facilityParams = {
                ...facility,
                obj: { ...data[indexInitFacility].obj },
              };
              this.props.onInitValue(facilityParams);
            }
            return _.compact(data);
          })
        );
      }, 500);
    });
  };

  render() {
    const { fieldForm } = this.props;
    let getFieldProps = {};
    if (fieldForm) {
      // console.log('fieldForm.option',fieldForm.option)
      getFieldProps = fieldForm.form.getFieldProps(fieldForm.name, {
        ...fieldForm.option,
      });
    }

    const isHidden = {
      style: {
        display: this.props.hideLabel ? 'none' : '',
      },
    };
    return (
      <Container>
        <div style={{ ...isHidden.style }}>
          <span>{this.props.label ? this.props.label : 'Cơ sở'}</span>
        </div>
        <Clearfix {...isHidden} width={8} />
        <div style={{ flex: 1 }}>
          <AsyncSelect
            isMulti={this.props.isMulti || false}
            isClearable
            isDisabled={this.props.isDisabled}
            cacheOptions
            defaultOptions
            loadOptions={this.promiseOptions}
            placeholder='-- Select --'
            style={{
              flex: 1,
            }}
            classNamePrefix='react-select-custom'
            options={this.state.itemList}
            {...getFieldProps}
          />
        </div>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/select-facility/index.js